import { defineStore } from 'pinia';
import { listInboxInsights, markInsightsRead } from '@/api/analytics-platform';

interface InboxState {
	unreadCount: number;
	projectCode: string;
}

// Unread 治疗回顾 count for the sidebar badge. Fetched on layout mount and
// refreshed after mark-read — no polling loop.
export const useInboxStore = defineStore('analytics-inbox', {
	state: (): InboxState => ({
		unreadCount: 0,
		projectCode: '',
	}),
	actions: {
		fetchUnread(projectCode: string) {
			if (!projectCode) return Promise.resolve();
			this.projectCode = projectCode;
			return listInboxInsights(projectCode, { limit: 1 })
				.then((res: any) => {
					this.unreadCount = res?.data?.unread_count ?? 0;
				})
				.catch((err: any) => {
					if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') return;
					// Menu may exist without backend reachability — badge just stays 0.
					this.unreadCount = 0;
				});
		},
		markRead(insightIds?: string[]) {
			if (!this.projectCode) return Promise.resolve();
			const payload = insightIds?.length ? { insight_ids: insightIds } : { all: true };
			return markInsightsRead(this.projectCode, payload).then((res: any) => {
				this.unreadCount = res?.data?.unread_count ?? 0;
			});
		},
	},
});
